import { assertNever } from "@homebound/activesupport";
import { Helmet } from "react-helmet-async";
import { Outlet, useParams } from "react-router-dom";
import { getStage } from "src/context";
import { MaxViewProvider, ToastProvider } from "src/contexts";
import { ConfiguratorHeader } from "src/pages/configurator/components";
import { ConfiguratorProvider } from "src/pages/configurator/Configurator.context";
import {
  AduStep,
  ExteriorStep,
  FlowStep,
  InteriorStep,
  OptionsStep,
  PlanStep,
  StructuralStep,
  SummaryStep,
} from "src/pages/configurator/stepTemplates";
import { DebugModeBottomBanner, LocalProdEnvironmentWarning } from "~components";

export function ConfiguratorLayout() {
  const stage = getStage();

  return (
    <>
      <Helmet>
        <title>Configurator</title>
      </Helmet>
      <ToastProvider>
        <ConfiguratorProvider>
          {/* MaxViewProvider is needed by InsideMapsIFrame for max view functionality */}
          <MaxViewProvider>
            <ConfiguratorHeader />
            {stage === "local-prod" && <LocalProdEnvironmentWarning />}
            <Outlet />
            <DebugModeBottomBanner />
          </MaxViewProvider>
        </ConfiguratorProvider>
      </ToastProvider>
    </>
  );
}

/** Watches the last `.../config/ccfg:1/:planStepId` route and renders the right component. */
export function ConfiguratorStep() {
  const step = useParams().step as FlowStep;
  switch (step) {
    case FlowStep.Community:
    case FlowStep.Lot:
      throw new Error("Community/Lot are not ConfiguratorSteps");
    case FlowStep.Plans:
      return <PlanStep />;
    case FlowStep.Exterior:
      return <ExteriorStep />;
    case FlowStep.Structural:
      return <StructuralStep />;
    case FlowStep.Interior:
      return <InteriorStep />;
    case FlowStep.Options:
      return <OptionsStep />;
    case FlowStep.Adu:
      return <AduStep />;
    case FlowStep.Summary:
      return <SummaryStep />;
    default:
      return assertNever(step);
  }
}
